import { IDocMetadata, IResourceParams } from './types'
import { createCourse, parseUnitModules } from './module'
import {
  fixBuildingTowardsBold,
  removeFigures,
  removeFontStyles,
  removeUnneededElements,
  styleContinuousLines,
  styleTables,
} from './utility'
import { parseHtmlString as parseHtmlStringUtil } from 'shared/utils'
import { wrapB, wrapTag } from '../html_utility'

export function parseHtmlString(contents: string) {
  const doc = parseHtmlStringUtil(contents, true)
  removeFigures(doc)
  styleTables(doc)
  removeFontStyles(doc)
  fixBuildingTowardsBold(doc)
  removeUnneededElements(doc)
  styleContinuousLines(doc)
  return doc
}

export async function parseUnits(params: IResourceParams[]) {
  const units = await parseUnitModules(params)
  return createCourse(
    {
      gradeId: units.gradeId,
      subjectId: units.subject.subject_id,
    },
    units.units,
  )
}

export function getDocMetadata<T = IDocMetadata>(doc: Document): T {
  const scripts = doc.getElementsByTagName('script')
  let metadata
  for (let i = 0; i < scripts.length; i++) {
    const script = scripts[i]
    if (script.getAttribute('type') === 'application/ld+json') {
      metadata = JSON.parse(script.text)
    }
  }
  return metadata
}

export function boldTitleSpan(title: string) {
  const style =
    "color: #000000; font-family: 'Lexend Deca', sans-serif; font-size: 24px;"
  return wrapB(wrapTag('span', title, { style }))
}
